// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KcWUz","textarea":"styles_textarea__34i47"};